/** Centres de secours : clés = ebrigade_id (section eBrigade). */
export const RESCUE_CENTER_LABELS: Record<number, string> = {
  0: 'Direction Nationale',
  2: 'CS Luxembourg',
  3: 'Équipe Médicale',
  7: 'CS Hainaut - Namur',
  9: 'CS Liège',
  10: 'Département Formation',
}

export const isKnownRescueCenter = (id: unknown): id is number => Number.isInteger(id) && (id as number) in RESCUE_CENTER_LABELS

/** Liste dédoublonnée et valide de centres, avec le centre par défaut toujours inclus en tête. */
export const normalizeRescueCenters = (centers: unknown, defaultCenter: number | null): number[] => {
  const list = Array.isArray(centers) ? centers.map(Number) : []
  return [...new Set([...(defaultCenter === null ? [] : [defaultCenter]), ...list])].filter(isKnownRescueCenter)
}
